import * as React from 'react'
import ReactTable, { RowInfo, Column, RowRenderProps, SortingRule } from 'react-table';
import TableLoadingIndicator from './TableLoadingIndicator'
import "react-table/react-table.css";
import { FilterInfo } from '../../common/models/CommonModels';
import './tablefix.css';
import { localizations } from '../../localization/localization';

const getExpandedStyle = (expanded: boolean) => {
    return {
        border: expanded ? "1px solid #013759" : null,
        backgroundColor: expanded ? "#013759" : null,
        color: expanded ? "white" : null
    }
}

interface TableViewProps {
    data: any[] | null;
    columns: any[],
    loading: boolean,
    toSubComponent?: (row: RowInfo) => JSX.Element | undefined,
    onFetchData?: (filters: FilterInfo) => void,
    initialSelection: any;
    defaultSortedColumns?: SortingRule[];
}

interface TableState {
    expanded: any;
    page: number;
    pageSize: number;
    sorted: any[];
}

class TableView extends React.Component<TableViewProps, TableState> {

    constructor(props: TableViewProps) {
        super(props);

        this.state = {
            expanded: {},
            page: 0,
            pageSize: 20,
            sorted: props.defaultSortedColumns || []
        }
        
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.handleSortedChange = this.handleSortedChange.bind(this);
    }

    public componentWillReceiveProps(nextProps: TableViewProps) {
        if (nextProps.initialSelection && this.props.data !== nextProps.data && this.props.data && nextProps.data && this.props.data.length !== nextProps.data.length) {

            if (nextProps.data && nextProps.data.length > 0) {

                const idToSearch = nextProps.initialSelection.id;

                const index = nextProps.data.findIndex(item => item.id === idToSearch);

                if (index >= 0) {
                    this.setState({
                        expanded: { [index]: true }
                    });
                }
            }
        }
    }

    public render() {
        const { data, columns, loading, toSubComponent, onFetchData } = this.props;

        return <div style={{ backgroundColor: "white" }}>
            <ReactTable
                data={data ? data : []}
                columns={columns}
                showPagination={true}
                defaultPageSize={20}
                page={this.state.page}
                pageSize={this.state.pageSize}
                sorted={this.state.sorted}
                onPageChange={this.handlePageChange}
                onPageSizeChange={this.handlePageSizeChange}
                onSortedChange={this.handleSortedChange}
                getTheadTrProps={() => {
                    return {
                        style: {
                            height: "40px"
                        }
                    }
                }}
                getTrProps={(state: any, rowInfo: RowInfo, column: Column | undefined) => {

                    const expanded = this.state.expanded[rowInfo.viewIndex] && this.state.expanded[rowInfo.viewIndex] !== false;

                    return {
                        style: Object.assign({}, {
                            textAlign: "center",
                            height: "52px",
                            padding: "10px 0",
                        },
                            getExpandedStyle(expanded))
                    };
                }}
                getTdProps={(state: any, rowInfo: RowInfo, column: Column | undefined, instance: any) => {
                    if (column && !!!column.expander) {
                        return {
                            onClick: (e: any) => {
                                this.setState(prevState => {
                                    let value = {};
                                    if (prevState.expanded[rowInfo.viewIndex] && prevState.expanded[rowInfo.viewIndex] !== "false") {
                                        value = false;
                                    }

                                    return { expanded: Object.assign({}, prevState.expanded, { [rowInfo.viewIndex]: value }) }
                                })
                            }
                        }
                    }
                    else {
                        return {}
                    }
                }}
                pageText={localizations.paging.page}
                ofText=" / "
                rowsText={localizations.paging.rows.rows}
                nextText={localizations.actions.next}
                previousText={localizations.actions.previous}
                expanded={this.state.expanded}
                loading={loading}
                loadingText={localizations.actions.loading}
                noDataText=""
                LoadingComponent={TableLoadingIndicator}
                minRows={0}
                className="-highlight"
                collapseOnSortingChange
                SubComponent={toSubComponent}
                onFetchData={onFetchData}
                onExpandedChange={expanded => this.setState({ expanded })}
            /></div>
    }

    private handlePageChange(page: any) {
        this.setState({
            page
        });
    }

    private handlePageSizeChange(pageSize: any, page: any) {
        this.setState({
            pageSize,
            page
        });
    }

    private handleSortedChange(sorted: any) {
        this.setState({
            sorted,
            expanded: {}
        });
    }
}

export default TableView;


// WEBPACK FOOTER //
// ./src/components/tables/TableView.tsx